import { useHttp } from '../http'

export const useEventHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`events/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`events`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`events/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`events`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`events/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`events/${id}/photo`, payload)
    }

    return {
        find,
        create,
        update,
        get,
        del,
        photo,
    }
}